import React from 'react';

import { Box, Button, RefreshIcon } from '@razorpay/blade/components';

import { EmptyListView } from 'components/ui/EmptyListView/EmptyListView';

export const SalaryStructuresErrorStateView = ({
  title,
  description,
  onRetry,
  retryText,
  onContactSupport,
  showContactUsCTA = false,
}: {
  title: string;
  description: string;
  onRetry?: () => void;
  retryText: string;
  onContactSupport?: () => void;
  showContactUsCTA?: boolean;
}) => {
  return (
    <EmptyListView title={title} description={description}>
      <Box display={'flex'} flexDirection={'row'} gap={'spacing.2'} marginX={'auto'}>
        <Button
          isFullWidth={!showContactUsCTA}
          size="medium"
          onClick={() => onRetry?.()}
          iconPosition="left"
          icon={RefreshIcon}>
          {retryText}
        </Button>
        {showContactUsCTA ? (
          <Button size="medium" onClick={() => onContactSupport?.()} variant="tertiary">
            Contact support
          </Button>
        ) : null}
      </Box>
    </EmptyListView>
  );
};
